import { Quill } from 'react-quill';
import colorsList from '../../utils/colorsList';

const Clipboard = Quill.import('modules/clipboard');
const Delta = Quill.import('delta');

const hexCodeRegex = /^#?([a-f0-9]{6}|[a-f0-9]{3})$/;

class CustomPasteModule extends Clipboard {

  constructor(quill, options) {
    super(quill, options);
    this.fontList = options.fontList;
    this.isInsideCustomLogicPopup = options.isInsideCustomLogicPopup;
  }

  onPaste(e) {
    var _this2 = this;
    let text = e.clipboardData.getData('text/plain');
    let html = e.clipboardData.getData('text/html');

    const cleanUnicode = (str) => {
      return typeof str === 'string' ? str.replace(
        /(?<!\\)[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, 
        ''
      ) : str;
    };

    text = cleanUnicode(text);
    html = cleanUnicode(html);

    console.log({ text, html });
    // e.preventDefault();
    // if (quill !== 'quill') {
    // super.onPaste(e);
    // return;
    const toolbar = this.quill.getModule('toolbar');
    const toolbarId =toolbar.container.id;
    const isHtmlBlock=toolbarId?.includes('htmltoolbar') 
    if (e.defaultPrevented || !this.quill.isEnabled()) return;
    var range = this.quill.getSelection();
    var delta = new Delta().retain(range.index);
    var layoutDOM = this.quill.scrollingContainer.closest('.vertical-layout');
    var scrollTop = layoutDOM?.scrollTop;
    var maxHeight = layoutDOM?.parentNode?.clientHeight || 0;
    this.container.focus({
      preventScroll: true
    });
    this.quill.selection.update(Quill.sources.SILENT);
    setTimeout(() => {
      let isShift = html === '';
      if (layoutDOM) {
        layoutDOM.scrollTop = scrollTop;
      }
      let pastedDelta = _this2.convert();
      if(pastedDelta?.ops){
        pastedDelta.ops = (pastedDelta.ops).map(item => {
          if (item.attributes && item.attributes.heading) {
              const { heading, ...restAttributes } = item.attributes;
              return {
                  ...item,
                  attributes: restAttributes
              };
          }
          return item;
        });
      }
      
      const formats = _this2.quill.getFormat(range.index);
      let isFromQuill = !isShift && pastedDelta.ops.find(delta => delta.attributes?.fromQuill === true) !== undefined;

      const newFormats = Object.assign({}, formats, Object.keys(formats).filter(key => key.startsWith("block-")).reduce((acc, key) => {
        let value = formats[key];
        if (value === 'normal') {
          value = false;
        }
        return { ...acc, [key.replaceAll('block-', '')]: value };
      }, {}));

      if (isShift) {
        let correctText = text.replaceAll('\r', '');
        let containsNewLines = correctText.includes('\n');
        if (containsNewLines) {
            let newDelta = new Delta();
            let newLines = correctText.split('\n');
            if (isFromQuill) { // TODO : Unable to identify without formatting that the copy has been made from quill
              newLines = correctText.replaceAll('\n\n', '\n').split('\n');
            }
            const count = newLines.length;
            newLines.forEach((splitText, index) => {
              if (splitText.length === 0) { // New line
                newDelta = newDelta.concat((new Delta()).insert('\n', formats));
              } else {
                newDelta = newDelta.concat((new Delta()).insert(splitText, newFormats));
                if (index < count) {
                  newDelta = newDelta.concat((new Delta()).insert('\n', formats));
                }
              }
            });
            pastedDelta = newDelta;
        } else {
          pastedDelta = pastedDelta.compose(new Delta().retain(pastedDelta.length(), newFormats));
        }
      } else if (!isFromQuill) {
        // Check if font family from pastedDelta is supported
        const previousLineFontFamily = formats['block-font'] || formats['font'];
        let previousOpIsText = pastedDelta.ops[0]?.insert?.length > 0 || pastedDelta.ops[0]?.insert.mention;
        pastedDelta.ops = pastedDelta.ops.reduce((acc, op) => {
          if(op.insert.mention) {
            previousOpIsText = true;
            return [...acc, op];
          } else if (op.insert.includes('\n') && op.insert !== '\n') {
            let newAcc = [...acc];
            let currentIndex = 0;
            let newlineIndex = op.insert.indexOf('\n');
            while(newlineIndex !== -1) {
              let line = op.insert.slice(currentIndex, newlineIndex);
              let lineDelta = Object.assign({}, op, { insert: line.length === 0 ? '\n' : line.replaceAll('\n', '') });
              newAcc = [...newAcc, lineDelta];
              if (newlineIndex !== 0 && line.replaceAll('\n', '').length > 0 && newlineIndex <= op.insert.length) {
                newAcc = [...newAcc, Object.assign({}, op, { insert: '\n' })];
              }
              currentIndex = newlineIndex + 1;
              newlineIndex = op.insert.indexOf('\n', newlineIndex + 1);
            }
            if (currentIndex < op.insert.length) {
              newAcc = [...newAcc, Object.assign({}, op, { insert: op.insert.slice(currentIndex) })];
            }
            return newAcc;
          } else {
            previousOpIsText = op.insert.replaceAll('\n', '').length !== 0;
            return [...acc, op];
          }
        }, []);
        console.log({ pastedDelta });
        !isHtmlBlock && pastedDelta.ops.forEach(delta => {
          if (delta.attributes) {
            if (delta.attributes['font'] && delta.attributes['font'] !== '') {
              const systemFonts = _this2.fontList().qlFonts;
              if (!systemFonts.includes(delta.attributes['font'])) {
                delta.attributes['font'] = previousLineFontFamily;
              }
              if (!systemFonts.includes(delta.attributes['block-font'])) {
                delta.attributes['block-font'] = delta.attributes['font'];
              }
            } else {
              delta.attributes['font'] = previousLineFontFamily;
              delta.attributes['block-font'] = previousLineFontFamily;
            }

            let applyFontSize = delta.attributes['size'] === undefined;
            if (delta.attributes['size'] && delta.attributes['size'] !== '') {
              if (delta.attributes['size'].startsWith('var')) {
                applyFontSize = true;
              }
            }
            if (applyFontSize) {
              delta.attributes['size'] = formats['block-size'] || formats['size'];
              delta.attributes['block-size'] = formats['block-size'] || formats['size'];
            } else if (typeof delta.attributes['size'] === 'string' && delta.attributes['size'].includes('pt')) {
              const pixels = Math.round(parseInt(delta.attributes['size'].replaceAll('pt', '')) * 1.33);
              delta.attributes['size'] = delta.attributes['block-size'] = `${pixels}px`;
            }

            let applyBold = delta.attributes['bold'] === undefined;
            if (!applyBold && delta.attributes['bold'] && delta.attributes['bold'] !== '') {
              if (typeof delta.attributes['bold'] === 'string' && delta.attributes['bold'].startsWith('var')) {
                applyBold = true;
              }
            }
            if (applyBold) {
              delta.attributes['bold'] = formats['block-bold'] || formats['bold'] || 'normal';
              delta.attributes['block-bold'] = formats['block-bold'] || formats['bold'] || 'normal';
            }

            let applyItalic = delta.attributes['italic'] === undefined;
            if (!applyItalic && delta.attributes['italic'] && delta.attributes['italic'] !== '') {
              if (typeof delta.attributes['italic'] === 'string' && delta.attributes['italic'].startsWith('var')) {
                applyItalic = true;
              }
            }
            if (applyItalic) {
              delta.attributes['italic'] = formats['block-italic'] || formats['italic'] || 'normal';
              delta.attributes['block-italic'] = formats['block-italic'] || formats['italic'] || 'normal';
            } else if (typeof delta.attributes['block-italic'] === 'boolean') {
              delta.attributes['italic'] = delta.attributes['italic'] ? 'true' : 'normal';
              delta.attributes['block-italic'] = delta.attributes['italic'] ? 'true' : 'normal';
            }

            let applyColor = delta.attributes['color'] === undefined;
            if (delta.attributes['color'] && delta.attributes['color'] !== '') {
              if (colorsList[delta.attributes['color']]) {
                delta.attributes['color'] = colorsList[delta.attributes['color']];
              } else if (!hexCodeRegex.test(delta.attributes['color'])) {
                applyColor = true;
              }
            }
            if (applyColor) {
              delta.attributes['color'] = formats['block-color'] || formats['color'];
              delta.attributes['block-color'] = formats['block-color'] || formats['color'];
            }

            let applyBackground = delta.attributes['background'] === undefined;
            if (delta.attributes['background'] && delta.attributes['background'] !== '') {
              if (colorsList[delta.attributes['background']]) {
                delta.attributes['background'] = colorsList[delta.attributes['background']];
              } else if (!hexCodeRegex.test(delta.attributes['background'])) {
                applyBackground = true;
              }
            }
            if (applyBackground) {
              delta.attributes['background'] = formats['block-background'] || formats['background'];
              delta.attributes['block-background'] = formats['block-background'] || formats['background'];
            }

            if (typeof delta.insert === 'string' && delta.insert.includes('\n')) {
              delta.attributes = Object.assign({}, delta.attributes, {
                lineheight: (`${delta.attributes['lineheight']}`.includes('em') ? delta.attributes['lineheight'] : undefined)  || formats['lineheight'],
                align: delta.attributes['align'] || formats['align'],
              }, Object.keys(formats).filter(key => key.startsWith("block-")).reduce((acc, key) => {
                return { ...acc, [key]: formats[key] };
              }, {}));
            }
          } else {
            delta.attributes = Object.assign({}, delta.attributes, newFormats);
          }

            if (delta.attributes['block-size'] !== delta.attributes['size']) {
              delta.attributes['block-size'] = delta.attributes['size'];
            }
            Object.keys(delta.attributes).forEach(attr => {
              const value = delta.attributes[attr];
              if (value === 'normal' && !attr.startsWith('block-')) {
                delta.attributes[attr] = false;
              }
            });
        });
        if (this.isInsideCustomLogicPopup) {
          pastedDelta.ops = pastedDelta.ops.map(change => {
            //set default style for copy pasted content inside the custom logic popup.
            change.attributes = {
              size: '16px',
              color: '#000000',
              font: 'Open sans',
              'block-font': 'Open sans',
              bold: false,
              'block-bold': 'normal',
              italic: false,
              'block-italic': 'normal',
              background: '#ffffff00',
              'block-background': '#ffffff00',
              'block-size': '16px',
            };
            return change;
          });
        }

      }

      if (!isFromQuill && !isHtmlBlock) {
      pastedDelta.ops = pastedDelta.ops.map(change => {
        if (typeof change.insert === 'string') {
          if (change.insert.includes('\n')) {
            return change;
          } else {
            return Object.assign({}, change, {
              attributes: Object.keys(change.attributes).reduce((acc, key) => {
                if (key.startsWith('block') || key === 'lineheight' || key === 'align' || key === 'list') {
                  return acc;
                } else {
                  return { ...acc, [key]: change.attributes[key] };
                }
              }, {})
            })
          }
        }
        return change;
      });
      }

      if (pastedDelta && pastedDelta.ops) {
        pastedDelta.ops = pastedDelta.ops.map(op => {
          const newOp = { ...op };
          if (op.attributes.color === undefined || op.attributes.color === 'inherit') {
            newOp.attributes = {...op.attributes, color: op.attributes['block-color']};
          }
          if (typeof op.insert === 'string') {
            // Clean unsupported chars from display text
            newOp.insert = cleanUnicode(op.insert);
          }
          return newOp;
        });
      }

      delta = delta.concat(pastedDelta).delete(range.length);

      _this2.quill.updateContents(delta, Quill.sources.USER); // range.length contributes to delta.length()
      
      let focus = _this2.quill.editor?.scroll?.domNode?.focus({
        preventScroll: true
      });

      _this2.quill.setSelection(delta.length() - range.length, 0, Quill.sources.SILENT);

      const bounds = _this2.quill.getBounds(delta.length() - range.length);
      if (layoutDOM && bounds.bottom > scrollTop + maxHeight) {
        layoutDOM.scrollTop = bounds.bottom;
      }

      _this2.quill.focus();
    }, 1);
      return;
  }
}

export default CustomPasteModule;
